import { API_STATUS } from '../../constants';
import { IUserData } from '../../types';
import { IUserSliceState } from './user.slice';
import { userStoreKey } from './user.const';

interface IState {
  [userStoreKey]: IUserSliceState;
}

const selectUserState = (state: IState) => {
  return state[userStoreKey];
};

const getUserApiStatus = (state: IState): API_STATUS => {
  return selectUserState(state).apiStatus;
};

const getUserData = (state: IState): IUserData | null => {
  return selectUserState(state).userData;
};

export const userSelectors = {
  getUserData,
  getUserApiStatus,
};
